import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; // adjust the path to your firebase.js
import { useNavigate } from "react-router-dom";

import "./header.css"

function Header({ isMobileView = false, isSidebarOpen = true, onToggleSidebar = () => {} }){

    const navigate = useNavigate()

    const handleLogout = async () => {

        try {
            await signOut(auth);
            navigate("/login", { replace: true });
        } catch (error) {
            console.error("Error logging out:", error);
        }
    };

    return(
        <>
            <div className="header">
                <div id="header_container">
                    <div className="header-left">
                        {isMobileView && (
                            <button
                                type="button"
                                className={`menu-toggle ${isSidebarOpen ? 'open' : ''}`}
                                aria-label="Toggle navigation"
                                onClick={onToggleSidebar}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        )}
                        <div className="logo-container">
                            <div className="logo-icon">J&Z</div>
                        </div>
                        <h1 id="header_title">J&Z Couture</h1>
                        <span className="header-subtitle">Dashboard</span>
                    </div>

                    <div className="header-right">
                        {/* <div className="user-info">
                            <div className="user-avatar">
                                <svg className="user-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                    <circle cx="12" cy="7" r="4"/>
                                </svg>
                            </div>
                            <span className="user-name"></span>
                        </div> */}
                        <button id="logout_button" onClick={handleLogout}>
                            <svg className="logout-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                                <polyline points="16,17 21,12 16,7"/>
                                <line x1="21" y1="12" x2="9" y2="12"/>
                            </svg>
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Header